import SEO from "../../../../src/components/seo";
import BackgroundImage from 'gatsby-background-image';
import { graphql } from 'gatsby';
import React from 'react';
export default {
  SEO,
  BackgroundImage,
  graphql,
  React
};